import React from 'react';
import { createUtilityPageLayoutClassName } from './utilityPageLayoutStyles';

type Width = 's' | 'm' | 'l' | 'xl';

type Props = {
  headerNode: React.ReactNode;
  footerNode: React.ReactNode;
  width: Width;
};

export const UtilityPageLayout: React.FC<Props> = (props) => {
  const { children, width, headerNode, footerNode } = props;

  const hasFooter = !!footerNode;

  const hasHeader = !!headerNode;

  return (
    <div
      className={createUtilityPageLayoutClassName('wrapper', {
        width,
        hasFooter,
        hasHeader,
      })}
    >
      <div
        className={createUtilityPageLayoutClassName('headerSlot', { width })}
      >
        {headerNode}
      </div>
      <div className={createUtilityPageLayoutClassName('bodySlot', { width })}>
        {children}
      </div>
      <div
        className={createUtilityPageLayoutClassName('footerSlot', { width })}
      >
        {footerNode}
      </div>
    </div>
  );
};
